var $cb6c30150c5ecac2$exports = {};
$cb6c30150c5ecac2$exports = {
    "valid": `Gyldig`
};


export {$cb6c30150c5ecac2$exports as default};
//# sourceMappingURL=da-DK.module.js.map
